"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styledDropdownConfig = exports.config = void 0;
var _Check = _interopRequireDefault(require("@tvg/fuse-icons/lib/Check"));
var _Error = _interopRequireDefault(require("@tvg/fuse-icons/lib/Error"));
var _fuseUtils = require("@tvg/fuse-utils");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var config = exports.config = {
  componentName: 'fuse-dropdown',
  icon: {
    error: {
      state: /*#__PURE__*/_react["default"].createElement(_Error["default"], null),
      label: ''
    },
    success: {
      state: /*#__PURE__*/_react["default"].createElement(_Check["default"], null),
      label: ''
    },
    size: 'small'
  }
};
var styledDropdownConfig = exports.styledDropdownConfig = {
  borderColor: {
    error: 'var(--color-functional-errorMid)',
    success: 'var(--color-functional-successMid)',
    completed: 'var(--color-greys-grey7)'
  },
  borderRadius: (0, _fuseUtils.BorderRadiusCss)('l'),
  borderWidth: '1px',
  componentName: config.componentName,
  helperTextColor: {
    error: 'var(--color-functional-errorMid)',
    success: 'var(--color-functional-successMid)'
  }
};